import { Injectable } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, of } from 'rxjs';
import { DialogActions } from '@app/_store';

// Browser messages for a lazy-loaded chunk that can't be fetched (Chrome/Edge, Firefox, Safari)
const CHUNK_LOAD_FAILED = /dynamically imported module|Importing a module script failed|ChunkLoadError/i;

/**
 * Each deploy replaces the hashed chunk files. A tab still running the previous version then fails to load a lazy page.
 * Instead of an error, the user gets a dialog whose only action is to reload straight to the page they were going to.
 */
@Injectable({ providedIn: 'root' })
export class NewVersionService {
  private dialogShown = false;

  constructor(
    private router: Router,
    private store: Store
  ) {}

  startMonitor() {
    this.router.events.pipe(filter((event): event is NavigationError => event instanceof NavigationError)).subscribe(event => {
      const message = event.error instanceof Error ? event.error.message : String(event.error);
      if (this.dialogShown || !CHUNK_LOAD_FAILED.test(message)) return;

      this.dialogShown = true;
      this.store.dispatch(
        new DialogActions.Confirm(
          'Ny version',
          'Det finns en ny version av Klubbavgift. Ladda om sidan för att fortsätta.',
          () => {
            window.location.href = event.url;
            return of(null);
          },
          false, // no cancel: no "Nej" button, no Esc and a static backdrop, so reloading is the only way on
          'Ladda om'
        )
      );
    });
  }
}
